/**
 * WordPress dependencies
 */
import { SVG, Path } from '@wordpress/primitives';

const queryPaginationPrevious = (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<Path d="M16 10.5v3h3v-3h-3zm-5 3h3v-3h-3v3zM7 9l-3 3 3 3 1-1-2-2 2-2-1-1z" />
	</SVG>
);

export default queryPaginationPrevious;
